import { Box } from '@mui/material';
import RVUsCalculator from 'components/common/RVUsCalculator/RVUsCalculator';
import useGlobalStyles from 'styles/globalStyles';

export default function RVUsCalculatorPage() {
  const globalStyles = useGlobalStyles();

  return (
    <Box className={globalStyles.container} p={3}>
      <Box>
        <RVUsCalculator />
      </Box>
    </Box>
  )
}

